import type { FaireProductEntity } from "../../entity_types/product";

export const p_33e5v7stkc: FaireProductEntity = {
  token: "p_33e5v7stkc",
  type: "product",
  name: "Coconut Rose Bath Soak",
  brandToken: "b_qgbeutab83",
  brandName: "Merigold",
  imageUrl:
    "https://cdn.faire.com/fastly/e5de860dcaa7f259e28d2d0887411ec04d472ef2c029fc8b6f1b88c554968c81.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3cc5eebf70dc3712976bb91d21b72dc2fbc221f6ba37e7c8a0da269dac52e36.jpeg",
    "https://cdn.faire.com/fastly/e033abaa3eb3b7b10c74c50b23a58d6245da598305f11a28c7ea7969b4e6fed5.jpeg",
    "https://cdn.faire.com/fastly/f13adea52b5b8be2e5809bb1c754f8690bc4d535438d4cac971dc852fa1355ac.jpeg",
    "https://cdn.faire.com/fastly/a86f70641bd204c646badc034f7d8e37abaabf88f75fd9650d8249d7eae64546.jpeg",
    "https://cdn.faire.com/fastly/a3c1a1173afb6753de1956418322a92a03d3685d94a73c630bd5e79be78d1dd7.jpeg",
    "https://cdn.faire.com/fastly/359c4b317f2194eb66372bb9c21dc5d7d12b5728d8ece1698d31272670ed196c.jpeg",
    "https://cdn.faire.com/fastly/c9ef6add3c23841a444ffccbcde95453cf3f5f9605242f21bc86439759b1a6a7.jpeg",
    "https://cdn.faire.com/fastly/006c776e90be8a659cd1aaa707663503494fe766233aaf6cf78712c4d35b0df4.jpeg",
    "https://cdn.faire.com/fastly/9f377927d534c20d227b6bf52ae0d648fc00ddc4a1455294813e0e463cb2cb7c.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Our Coconut Rose Bath Soak—a luxurious blend of mineral-rich salts, softening coconut milk, and delicate rose petals, designed to nourish and restore while inviting a moment of stillness and care.\n\n• Organic coconut milk is cherished for its creamy, skin-loving properties, helping to nourish, soften, and restore hydration to dry skin.\n\n• Organic rose petals are traditionally celebrated for their calming, soothing qualities and their ability to promote a radiant, healthy-looking glow.\n\n• Himalayan salt offers a natural source of trace minerals that can help balance and soften the skin, leaving it feeling smooth and refreshed.\n\nThis is more than a bath—it's an invitation to slow down, soften into presence, and care for your skin with intention and love.",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:16.013Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
